import type { Artist } from "@/types/types";
import { MediaCard } from "./MediaCard";

export function ArtistCard({ artist }: { artist: Artist }) {
  return (
    <MediaCard to={`/artist/${artist.id}`} coverId={artist.cover_id} title={artist.name} subtitle="Artiste" round />
  );
}
